import { List, Text } from "@mantine/core";
import React from "react";

const BrowserNotSupported = () => {
  return (
    <>
      <Text size="lg">
        Your browser is out of date and does not support modern features
        required for this application to run securely and reliably.
      </Text>
      <Text mt="md" size="lg">Please update your browser or switch to one of these:</Text>
      <List mt="xs" size="lg">
        <List.Item>Google Chrome</List.Item>
        <List.Item>Mozilla Firefox</List.Item>
        <List.Item>Microsoft Edge</List.Item>
        <List.Item>Safari (version 15.4 or newer)</List.Item>
      </List>
    </>
  );
};

export default BrowserNotSupported;
